export const HOME = '/'
export const DEMO = '/demo'
export const CREATE_WALLET_NAV = '/create'
export const RESTORE_WALLET_NAV = '/restore'
export const BACKUP_WALLET_NAV = '/backup'
export const RECEIVE_WALLET_NAV = '/receive'
export const UNLOCK_WALLET_NAV = '/unlock'
export const PASSWORD_CHANGE_NAV = '/password'
export const PRIVATE_KEY_NAV = '/private-key'


// WEBPACK FOOTER //
// ./src/constants/navigation.js